import { FaCheck } from 'react-icons/fa';

const BLOCK = 'LStudio__app_form_wizard';

export const FormWizard = ({
    steps = [], currentStep = 0, onStepChange = null,
    maxVisitedStep = currentStep, children,
}) => (
    <div className={BLOCK}>
        <nav className={`${BLOCK}__steps`} aria-label="Progreso del formulario">
            {steps.map((step, index) => {
                const isActive = index === currentStep;
                const isDone = index < currentStep;
                const canOpen = index <= maxVisitedStep;

                return (
                    <button
                        key={step.id ?? index}
                        type="button"
                        className={`${BLOCK}__step`}
                        data-active={isActive}
                        data-done={isDone}
                        disabled={!canOpen || !onStepChange}
                        onClick={() => canOpen && onStepChange?.(index)}
                    >
                        <span className={`${BLOCK}__step_index`}>
                            {isDone ? <FaCheck /> : index + 1}
                        </span>
                        <span className={`${BLOCK}__step_text`}>
                            <small>{step.shortLabel ?? `Paso ${index + 1}`}</small>
                            <strong>{step.title}</strong>
                        </span>
                    </button>
                );
            })}
        </nav>

        <section className={`${BLOCK}__panel`}>
            {steps[currentStep]?.description && (
                <header className={`${BLOCK}__header`}>
                    <span>Paso {currentStep + 1} de {steps.length}</span>
                    <h2>{steps[currentStep]?.title}</h2>
                    <p>{steps[currentStep]?.description}</p>
                </header>
            )}
            {children}
        </section>
    </div>
);
